import {Component} from 'react';
import "./ForParents/forParents.css";
import "../../css/styles.css";

class ParentsGameInfo extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            userName: "",
            modalOpen: true,
        }
    }
   
      
    render() {
        this.headerClass = "font-weight-bold mt-3";
        this.textClass = "mr-4";
                   
    return <>
        <div className="col-8">
        <div className="card mt-3 rounded-corners-lg height-max">
            <button className="pages-back-button ml-4 mt-4" 
                        onClick ={()=> this.props.goBack()}>
                                Back
            </button>
            <h3 className="mt-0 p-0 text-center">For Parents and Teachers</h3>
            <h5 className="text-center">Game Information</h5>
                            
            <div className="overflow-scroll mr-3 ml-3 mb-5">
                           
                <p className={this.textClass}>     
                  The main objective of the MoneyTrain game is to teach some basic concepts
                  of financial literacy.   In addition to tracking the students’ cash position,  
                  we have also introduced the concept of “Mood Points” to help simulate some of 
                  the work/life balance decisions that result from monetary and working decisions. 
                  There are three parts to the game:
                </p>
                <h6 className={this.headerClass}>Getting Started:</h6>  
                <p className={this.textClass}>  
                  During the getting started part of the game, players
                  will make choices that impact their game experience.  These choices involve
                  key decisions such as the job (career) that they will pursue, their home 
                  choice and what car they wish to purchase.  These decisions determine their
                  monthly wages and their starting cash position.  After the key decisions are complete, 
                  the player moves to the Playing the Game part of the game. 
                </p>
                <h6 className={this.headerClass}>Playing the Game:</h6>  
                <p className={this.textClass}>  
                  In this part of the game, players experience a variety of real-life events and make 
                  decisions in response. Each choice affects their cash balance and mood points, which 
                  reflect financial and emotional well-being.  Players also have the opportunity to revisit 
                  and change some of the key decisions they made earlier in the game such as job choice 
                  or housing to increase their income or reduce expenses. As the game progresses, new 
                  features are unlocked, including savings, credit cards, and investments, each introducing 
                  important financial concepts through realistic scenarios.  The goal of the game is to 
                  maximize both savings and mood points. The game ends in one of three ways:
                </p>
                <ul className="bulleted-list">
                      <li>The player runs out of money or mood points</li>
                      <li>The player chooses to end the game</li>
                      <li>30 in-game years have passed</li>
                </ul>
                <h6 className={this.headerClass}>End Game:</h6> 
                <p className={this.textClass}>  
                  During the End Game part of the game, the final cash position and mood points for the player 
                  will be displayed.  In addition, the game displays their position on the game leader board and 
                  provides tips for improving their game should they choose to play again.  Individuals can choose
                  to play the game again to experiment with different life choices and work to improve their
                  score.
                </p>
          
            </div>
        </div>    
       </div>
    </>
    }

}

export default ParentsGameInfo;